"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createWaitForState = function createWaitForState() {
  var store = void 0;

  var waitForState = function waitForState(predicate) {
    return new Promise(function (resolve) {
      if (predicate(store.getState())) {
        resolve();
        return;
      }

      var unsubscribe = store.subscribe(function () {
        if (predicate(store.getState())) {
          unsubscribe();
          resolve();
        }
      });
    });
  };

  var setStore = function setStore(s) {
    store = s;
  };

  return { waitForState: waitForState, setStore: setStore };
};

exports.default = createWaitForState;